// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Comment-module--bx--text-truncate--end--16VEm";
export var bxTextTruncateFront = "Comment-module--bx--text-truncate--front--91r9b";
export var container = "Comment-module--container--2--2i";
export var fadeout = "Comment-module--fadeout--ZuhBu";
export var focused = "Comment-module--focused--1Piqo";
export var textarea = "Comment-module--textarea--3Em9_";